<template>
<div class="main">
	<v-tabs
		show-arrows
	>
		<v-tabs-slider />
		<v-tab
			v-for="n in items"
			:to="'#' + n.key"
			:key="n.name"
		>
			{{n.name}}
		</v-tab>

		<v-tabs-items>
			<v-tab-item
				v-for="i in items"
				:id="i.key"
				:key="i.name"
			>
				<v-card flat>
					<component :is="i.component" />
				</v-card>
			</v-tab-item>
		</v-tabs-items>
	</v-tabs>

	<v-layout justify-center class="top">
		<v-flex d-flex md1>
			<v-btn color="success" dark @click="save">
				<v-icon>save</v-icon>
				<span>{{$t('common.save')}}</span>
			</v-btn>
		</v-flex>
	</v-layout>
</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Item from './Item'
import Citizenship from './Citizenship'
import MainTab from './tabs/MainTab'
import CzIsco from './tabs/CzIsco'
import CzNace from './tabs/CzNace'

import { notify } from '../../utils/notifications'
import { tabName } from '../../utils/helpers'

export default {
	data: vm => ({
		items: [
			{
				key: 'main',
				name: vm.$t('workers.main'),
				component: MainTab
			},
			{
				key: 'cz-isco',
				name: vm.$t('workers.cz_isco'),
				component: CzIsco
			},
			{
				key: 'cz-nace',
				name: vm.$t('workers.cz_nace'),
				component: CzNace
			},
		]
	}),
	components: {
		Item,
		Citizenship,
		MainTab,
		CzIsco,
		CzNace
	},
	methods: {
		...mapActions({
			saveSetting: 'settings/changeSetting'
		}),
		save() {
			const citizenship = this.settings.citizenship.map(
				item => item.code || item
			)
			const {
				educationTypes,
				czIscos,
				czNaces,
				scanTypes,
				tituls1,
				tituls2,
				insuranceCompanies,
			} = this.settings
			this.saveSetting({
				citizenship,
				educationTypes,
				czIscos,
				czNaces,
				scanTypes,
				tituls1,
				tituls2,
				insuranceCompanies,
			}).then(() => {
				this.$notify({
					...notify,
					text: this.$t('notifications.updated',
					{ type: this.$t('navigation.settings') })
				})
			})
		}
	},
	computed: {
		...mapState({
			settings: ({ settings }) => settings.settings
		})
	}
}
</script>

<style scoped>
.main {
	width: 100%;
}
.top {
	padding-top: 15px;
}
</style>
